// extracted by mini-css-extract-plugin
module.exports = {"FriendRequestContainer":"Request_FriendRequestContainer__2QGY7","RequestDetailContainer":"Request_RequestDetailContainer__3UxYN","Date":"Request_Date__1bU0_"};